import { AutomatedTriggerType, CampaignStatus, CampaignType } from '../../../../graphQL/generated/enums'
import { $RootStore } from '../../../../src/stores/RootStore'
import { SetupTaskId } from '../setupTasksData'
import { SetupStep } from './d'

export const GMBOnboardingStepIds = {
  profileAnalyser: `${SetupTaskId.GMBOnboarding}-profileAnalyser`,
  syncReviews: `${SetupTaskId.GMBOnboarding}-syncReviews`,
  websiteOptimisation: `${SetupTaskId.GMBOnboarding}-websiteOptimisation`,
  reviewGathering: `${SetupTaskId.GMBOnboarding}-reviewGathering`,
  servicePages: `${SetupTaskId.GMBOnboarding}-servicePages`,
} as const

const gmbOnboardingSteps: SetupStep[] = [
  {
    title: 'Google Business Profile analyser',
    description: 'See how your profile is performing and get actionable tips to improve visibility.',
    id: GMBOnboardingStepIds.profileAnalyser,
    taskId: SetupTaskId.GMBOnboarding,
    icon: 'searchProperty',
    check: (rootStore: $RootStore) => {
      return rootStore.googleBusinessProfileStore.isFullySetup && rootStore.googleBusinessProfileStore.hasFetched
    },
    startAction: async (_rootStore: $RootStore) => {
      // Platform-specific action defined in stepData.ts
    },
    dependsOnStepIds: [],
  },
  {
    title: 'Sync Google reviews',
    description: 'Sync reviews from your Google Business Profile to build trust and showcase your reputation.',
    id: GMBOnboardingStepIds.syncReviews,
    taskId: SetupTaskId.GMBOnboarding,
    icon: 'starOutline',
    check: (rootStore: $RootStore) => {
      return rootStore.setupStore.didAction === 'syncReviews'
    },
    startAction: async (_rootStore: $RootStore) => {
      // Platform-specific action defined in stepData.ts
    },
    dependsOnStepIds: [],
  },
  {
    title: 'Website optimisation',
    description: 'Optimise your profile to rank higher in local search results.',
    id: GMBOnboardingStepIds.websiteOptimisation,
    taskId: SetupTaskId.GMBOnboarding,
    icon: 'web',
    check: (rootStore: $RootStore) => {
      return rootStore.setupStore.didAction === 'optimisedWebsite'
    },
    startAction: async (_rootStore: $RootStore) => {
      // Platform-specific action defined in stepData.ts
    },
    dependsOnStepIds: [],
  },
  {
    title: 'Automated review requests',
    description: 'Request reviews from clients after their booking to grow your online reputation.',
    id: GMBOnboardingStepIds.reviewGathering,
    taskId: SetupTaskId.GMBOnboarding,
    icon: 'writeReview',
    check: (rootStore: $RootStore) => {
      const automatedCampaigns = rootStore.emailCampaignStore.items.filter(c => c.data.type === CampaignType.Automated && c.data.status === CampaignStatus.Active)
      const hasReviewReminder = automatedCampaigns.some(c => c.data.triggerType === AutomatedTriggerType.TrReviewReminder)
      return hasReviewReminder
    },
    startAction: async (_rootStore: $RootStore) => {
      // Platform-specific action defined in stepData.ts
    },
    dependsOnStepIds: [],
  },
  // We will introduce these when the features are available
  // {
  //   title: 'Create service pages',
  //   description: 'Generate SEO-friendly service pages to help new clients find and book you online.',
  //   id: GMBOnboardingStepIds.servicePages,
  //   taskId: SetupTaskId.GMBOnboarding,
  //   icon: 'addPage',
  //   check: (_rootStore: $RootStore) => {
  //     // TODO: Implement check
  //     return false
  //   },
  //   startAction: async (_rootStore: $RootStore) => {
  //     // Platform-specific action defined in stepData.ts
  //   },
  //   dependsOnStepIds: [],
  // },
]

export default gmbOnboardingSteps
